"use strict";
import { __exports as e } from "./index.es286.js";
import { __require as u } from "./index.es287.js";
import n from "react";
var o;
function d() {
  return o ? e : (o = 1, (function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "RouterContext", {
      enumerable: !0,
      get: function() {
        return r;
      }
    });
    const r = (/* @__PURE__ */ (/* @__PURE__ */ u())._(n)).default.createContext(null);
    process.env.NODE_ENV !== "production" && (r.displayName = "RouterContext");
  })(e), e);
}
export {
  d as __require
};
//# sourceMappingURL=index.es255.js.map
